var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuyElectricity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.68629 0 0 2.68629 0 6C0 7.86519 0.851973 9.53203 2.18519 10.6313C3.23747 11.4989 4 12.4427 4 13.4557V14.1003C4 14.4459 4.23625 14.7468 4.57205 14.8289C5.03046 14.9408 5.50883 15 6 15C6.49117 15 6.96954 14.9408 7.42795 14.8289C7.76375 14.7468 8 14.4459 8 14.1003V13.4557C8 12.4427 8.76252 11.4989 9.81481 10.6313C11.148 9.53203 12 7.86519 12 6C12 2.68629 9.31371 0 6 0Z",
    fill: "#F9A01B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8628 16.4144C4.45329 16.3522 4.07086 16.6337 4.00862 17.0432C3.94638 17.4527 4.22789 17.8352 4.6374 17.8974C5.08221 17.965 5.53731 18 6.0001 18C6.4629 18 6.918 17.965 7.3628 17.8974C7.77232 17.8352 8.05383 17.4527 7.99159 17.0432C7.92935 16.6337 7.54691 16.3522 7.1374 16.4144C6.76694 16.4708 6.38718 16.5 6.0001 16.5C5.61302 16.5 5.23326 16.4708 4.8628 16.4144Z",
    fill: "#F9A01B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyElectricity);
export default __webpack_public_path__ + "static/media/buy-electricity.43ba12607d06a1cdc6f69b4ba7488bb2.svg";
export { ForwardRef as ReactComponent };